import Quill from 'quill';

const getSemanticHTML = Quill.prototype.getSemanticHTML;

Quill.prototype.getSemanticHTML = function (this: Quill, ...args: any[]): string {
  const html: string = (getSemanticHTML as any).apply(this, args);
  return html.replace(/(?<!&nbsp;)&nbsp;(?!&nbsp;)/g, ' ');
};
